/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateAutojoinDomainInput = {
    id: string;
    name?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type updateAutojoinDomainMutationVariables = {
    input: UpdateAutojoinDomainInput;
};
export type updateAutojoinDomainMutationResponse = {
    readonly updateAutojoinDomain: {
        readonly AutojoinDomain: {
            readonly id: string;
            readonly name: string | null;
        } | null;
    } | null;
};
export type updateAutojoinDomainMutation = {
    readonly response: updateAutojoinDomainMutationResponse;
    readonly variables: updateAutojoinDomainMutationVariables;
};



/*
mutation updateAutojoinDomainMutation(
  $input: UpdateAutojoinDomainInput!
) {
  updateAutojoinDomain(input: $input) {
    AutojoinDomain {
      id
      name
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateAutojoinDomainInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateAutojoinDomainPayload",
    "kind": "LinkedField",
    "name": "updateAutojoinDomain",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AutojoinDomain",
        "kind": "LinkedField",
        "name": "AutojoinDomain",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateAutojoinDomainMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateAutojoinDomainMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateAutojoinDomainMutation",
    "operationKind": "mutation",
    "text": "mutation updateAutojoinDomainMutation(\n  $input: UpdateAutojoinDomainInput!\n) {\n  updateAutojoinDomain(input: $input) {\n    AutojoinDomain {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'e6b2c7c7a247b1a20ec02bfcae5d42af';
export default node;
